import { Routes } from '@angular/router';

const title = 'Configuración';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'especie',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Especies' }] },
        loadComponent: () => import('./pages/especie-lista/especie-lista.component'),
      },
      {
        path: 'item/:tipoMascotaId',
        title,
        data: { ...data, urls: [{ url: '/especie', title: 'Especies' }, { title: 'Razas' }] },
        loadComponent: () => import('./pages/raza-lista/raza-lista.component'),
      },
    ],
  },
];
